import { useRef } from "react";
import { useVirtualizer } from "@tanstack/react-virtual";
import OrgTreeRow from "./OrgTreeRow";

const ROW_HEIGHT_ESTIMATE = 52;
const MAX_HEIGHT = 600;

const VirtualOrgTree = ({
  flatRows,
  disclosure,
  year,
  monthOptions,
  targetFrequency,
  collapsedNodes,
  onToggleCollapse,
}) => {
  const scrollContainerRef = useRef(null);

  const virtualizer = useVirtualizer({
    count: flatRows.length,
    getScrollElement: () => scrollContainerRef.current,
    estimateSize: () => ROW_HEIGHT_ESTIMATE,
    overscan: 5,
    measureElement: (el) => el.getBoundingClientRect().height,
  });

  return (
    <div
      ref={scrollContainerRef}
      className="overflow-auto"
      style={{ maxHeight: MAX_HEIGHT }}
    >
      <div
        style={{
          height: virtualizer.getTotalSize(),
          width: "100%",
          position: "relative",
        }}
      >
        {virtualizer.getVirtualItems().map((virtualItem) => {
          const row = flatRows[virtualItem.index];
          return (
            <div
              key={row.collapseKey}
              ref={virtualizer.measureElement}
              data-index={virtualItem.index}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                transform: `translateY(${virtualItem.start}px)`,
              }}
            >
              <OrgTreeRow
                node={row.node}
                disclosure={disclosure}
                year={year}
                monthOptions={monthOptions}
                targetFrequency={targetFrequency}
                depth={row.depth}
                hasChildren={row.hasChildren}
                collapseKey={row.collapseKey}
                isCollapsed={collapsedNodes.has(row.collapseKey)}
                onToggleCollapse={onToggleCollapse}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VirtualOrgTree;
